import React from "react";
import MANIFEST from "@/data/imageManifest.json";

// Serves the pre-generated WebP srcset (scripts/optimize-images.py) for known images.
export const OptImg = ({ src, sizes = "(min-width: 1024px) 50vw, 100vw", alt = "", ...rest }) => {
  const m = MANIFEST[src];
  if (!m) return <img src={src} alt={alt} {...rest} />;
  const last = m.set[m.set.length - 1];
  return (
    <img
      src={last[0]}
      srcSet={m.set.map(([p, w]) => `${p} ${w}w`).join(", ")}
      sizes={sizes}
      width={m.w}
      height={m.h}
      decoding="async"
      alt={alt}
      {...rest}
    />
  );
};

export default OptImg;
